import history from "./History";
import { useIdleTimer } from "react-idle-timer";
import Modal from "../components/Modal";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import { useCookies } from "react-cookie";
import { useRecoilState } from "recoil";
import {
  accountAtom,
  defaultAccount,
} from "../modules/Login/atoms/AccountAtom";

export const IdleModal = ({ openModal, setOpenModal }) => {
  const [userAccount, setAccount] = useRecoilState(accountAtom);
  function Logout() {
    localStorage.clear();
    setAccount(defaultAccount);
    history.push("/");
    window.location.reload();
  }

  return (
    <Modal
      isOpen={openModal}
      onClose={() => {
        Logout();
        setOpenModal(false);
      }}
      hasCloseButton={false}
      width="3.5"
    >
      <div className="space-y-4">
        <div>
          {/* <div className="swal2-icon swal2-warning swal2-icon-show">
            <div className="swal2-icon-content items-center ml-7">?</div>
          </div> */}
          <div className="sm:flex sm:items-start -mt-2">
            <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10 mt-4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                className="h-6 w-6 text-secondary"
                aria-hidden="true"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                ></path>
              </svg>
            </div>
            <div className="qConfirmation">
              You will be logged out due to inactivity.
            </div>
          </div>
        </div>
        <div className="flex justify-end gap-x-2">
          <button
            className="-mt-5 text-sm px-3 py-2 font-semibold shadow-md text-white bg-secondary rounded-md outline-none Savebtn hover:bg-btnhSave focus:outline-none focus:ring-2 focus:ring-btnolSave focus:ring-opacity-50"
            onClick={() => {
              Logout();
            }}
          >
            Ok
          </button>
        </div>
      </div>
    </Modal>
  );
};
const IdleChecker = ({ children }) => {
  const [openModal, setOpenModal] = useState(false);

  const { pathname } = useLocation();

  const handleOnIdle = () => {
    if (pathname && !(pathname === "/")) {
      setOpenModal(true);
    }
  };

  useIdleTimer({
    timeout: 1000 * 60 * 60,
    onIdle: handleOnIdle,
    debounce: 500,
  });

  return (
    <>
      <IdleModal openModal={openModal} setOpenModal={setOpenModal} />
      {children}
    </>
  );
};
export default IdleChecker;
